import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { COLORS, fontFamilyAll } from '../assets/commonComponents/COLORS';
import { CardContentStyled, CardMediaStyled, CardGrid, CustomCard } from '../assets/css/aboutCard';

export default function AboutCards({ isMobile, data, isHeading }) {
  return (
    <Box
      sx={{
        padding: { xs: 2, sm: 4, md: 8 },
        maxWidth: { xl: '1600px' }, // Cap width for 4K screens
        mx: 'auto', // Center content
      }}
    >
      {isHeading && (
        <Typography
          variant="h4"
          fontWeight="bold"
          color={COLORS.pinkColor}
          textAlign="center"
          fontFamily={fontFamilyAll}
          mb={{ xs: 2, sm: 4 }}
          sx={{ fontSize: { xs: '1.8rem', sm: '2.2rem' } }}
        >
          Our Services
        </Typography>
      )}

      <Grid
        container
        spacing={{ xs: 2, sm: 3, md: 4 }}
        display="flex"
        justifyContent="center"
        alignItems="stretch"
      >
        {data.map((item, index) => (
          <CardGrid
            item
            key={index}
            xs={12}
            sm={6}
            md={3}
            sx={{ minWidth: { xs: '280px', sm: 'auto' } }} // Prevent cards from being too narrow
          >
            <CustomCard
              elevation={0}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {item.image && (
                <CardMediaStyled
                  component="img"
                  sx={{
                    height: { xs: '200px', sm: '250px' }, // Smaller height for mobile
                    objectFit: 'cover',
                    borderRadius: '10px',
                  }}
                  image={item.image}
                  alt={item.title}
                />
              )}
              <CardContentStyled
                sx={{
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  padding: { xs: 2, sm: 3 }, // Responsive padding
                }}
              >
                <Box>
                  <Typography
                    gutterBottom
                    variant="h6"
                    fontWeight="bold"
                    component="div"
                    fontFamily={fontFamilyAll}
                    sx={{
                      color: COLORS.pinkColor,
                      fontSize: { xs: '1rem', sm: '1.2rem' },
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    fontFamily={fontFamilyAll}
                    sx={{
                      color: 'text.secondary',
                      lineHeight: 1.7,
                      fontSize: { xs: '0.9rem', sm: '1rem' },
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 4, // Limit to 4 lines
                      WebkitBoxOrient: 'vertical',
                    }}
                    textAlign="justify"
                  >
                    {item.description}
                  </Typography>
                </Box>

                <Typography
                  variant="body2"
                  fontFamily={fontFamilyAll}
                  component="a"
                  href={item.link || '#'} // Assumes data includes a link field
                  sx={{
                    color: COLORS.purpleColor,
                    lineHeight: 1.7,
                    cursor: 'pointer',
                    mt: 1,
                    textAlign: { xs: 'center', sm: 'left' },
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                  role="button"
                  tabIndex={0}
                >
                  View More
                </Typography>
              </CardContentStyled>
            </CustomCard>
          </CardGrid>
        ))}
      </Grid>
    </Box>
  );
}